import { tick } from 'svelte';

/**
 * Portal an element to a target element or CSS selector.
 * Converted to TS from : https://github.com/romkor/svelte-portal/blob/master/src/Portal.svelte
 */
export function portal(el: HTMLElement | string, target = 'body' as string | HTMLElement) {
  let targetEl;
  async function update(newTarget: HTMLElement | string) {
    target = newTarget;
    if (typeof target === 'string') {
      targetEl = document.querySelector(target);
      if (targetEl === null) {
        await tick();
        targetEl = document.querySelector(target);
      }
      if (targetEl === null) {
        throw new Error(`No element found matching css selector: "${target}"`);
      }
    } else if (target instanceof HTMLElement) {
      targetEl = target;
    } else {
      throw new TypeError(
        `Unknown portal target type: ${
          target === null ? 'null' : typeof target
        }. Allowed types: string (CSS selector) or HTMLElement.`
      );
    }
    targetEl.appendChild(el as HTMLElement);
    (el as HTMLElement).hidden = false;
    (el as HTMLElement).classList.add('portal-modal');
  }

  function destroy() {
    const elem = el as HTMLElement;
    if (elem.parentNode) {
      elem.parentNode.removeChild(elem);
    }
  }

  update(target);
  return {
    update,
    destroy
  };
}
